import styled from 'styled-components'

export const StyledContainer = styled.article`
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  height: 100%;

  & > section {
    flex: 1;
    padding-right: 24px;
    height: 100%;
  }

  & > aside {
    width: 312px;
    flex: 0 0 312px;
    min-height: 0px;
    height: 100%;
  }
`
